<div class="front-wrap">
	<div class="front-store-content">
		<div class="container">
			<div class="order-card pay-faild">
				<img src="/assets/img/card.png" />
				<h2>Payment Failed</h2>
				<p>Your payment got failed, Redirecting you back to cart page</p>
				<a class="mat-btn" (click)="fn_RedirectToCart()">  Try Again</a>
			</div>
		</div>
	</div>
</div>